import { render, staticRenderFns } from "./BusinesserAdd.vue?vue&type=template&id=88366828&"
import script from "./BusinesserAdd.vue?vue&type=script&lang=js&"
export * from "./BusinesserAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports